import { render } from "./MenuEvent.vue?vue&type=template&id=7483c658&scoped=true"
import script from "./MenuEvent.vue?vue&type=script&lang=js"
export * from "./MenuEvent.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=7483c658&scoped=true&lang=css"
import "@/assets/css/user/pages/menu.css?vue&type=style&index=1&id=7483c658&scoped=true&lang=css"
import "@/assets/css/user/pages/touchbox.css?vue&type=style&index=2&id=7483c658&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=3&id=7483c658&scoped=true&lang=css"
import "@/assets/css/user/dark/menu-dark.css?vue&type=style&index=4&id=7483c658&scoped=true&lang=css"
import "@/assets/css/user/dark/touchbox-dark.css?vue&type=style&index=5&id=7483c658&scoped=true&lang=css"
import "./MenuEvent.vue?vue&type=style&index=6&id=7483c658&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7483c658"]])

export default __exports__